import React from "react";
import { motion } from "framer-motion";
import { REVEAL, revealDelayed } from "@/lib/motion";

const STEPS = [
  {
    title: "Free sales audit.",
    body: "A 30 minute call on how you get and handle leads today. You get a one-page summary within 48 hours.",
  },
  {
    title: "A clear plan and price.",
    body: "We recommend what to build, which tools to use and what it costs. No surprises.",
  },
  {
    title: "Live in weeks, not months.",
    body: "We build it, test it and hand it over to your team.",
  },
];

export const HomeHowItWorks = () => (
  <section id="how-it-works" className="bg-[#3D472D] px-6 sm:px-8 py-20 sm:py-28 scroll-mt-20" data-testid="home-how-it-works">
    <div className="max-w-5xl mx-auto">
      <motion.h2 {...REVEAL} className="font-fraunces font-extrabold text-3xl sm:text-4xl tracking-tight text-[#F4E9D8]">
        How it works
      </motion.h2>
      <div className="mt-12 grid md:grid-cols-3 gap-5">
        {STEPS.map((s, i) => (
          <motion.div
            key={s.title}
            {...revealDelayed(i * 0.08)}
            className="rounded-2xl border border-[#F4E9D8]/20 bg-[#55633F]/50 p-7 sm:p-8"
            data-testid={`how-step-${i + 1}`}
          >
            <span className="font-fraunces font-extrabold text-sm text-[#C8703A]">{String(i + 1).padStart(2, "0")}</span>
            <h3 className="mt-4 font-fraunces font-extrabold text-base md:text-lg text-[#F4E9D8]">{s.title}</h3>
            <p className="mt-3 text-sm text-[#F4E9D8]/70 leading-relaxed">{s.body}</p>
          </motion.div>
        ))}
      </div>
    </div>
  </section>
);

export default HomeHowItWorks;
